import { ref, watch } from 'vue'
import { useToast } from 'primevue/usetoast'
import { useBoekhouding } from './useBoekhouding'
import { useImportExport } from './useImportExport'
import { format } from 'date-fns'

export function useAutosave() {
  const { transactions, splitRules, businessRules, relaties, accounts, fileHandle } = useBoekhouding()
  const { saveFile } = useImportExport()
  const toast = useToast()

  const isSaving = ref(false)
  const lastSaved = ref<Date | null>(null)
  let timer: ReturnType<typeof setTimeout> | null = null

  watch(
    [transactions, splitRules, businessRules, relaties, accounts],
    () => {
      if (!fileHandle.value) return
      if (timer) clearTimeout(timer)
      timer = setTimeout(async () => {
        if (!fileHandle.value) return

        const permission = await fileHandle.value.queryPermission({ mode: 'readwrite' })
        if (permission !== 'granted') return

        isSaving.value = true
        try {
          await saveFile()
          lastSaved.value = new Date()
        } catch {
          toast.add({ severity: 'error', summary: 'Opslaan mislukt', detail: 'Controleer bestandstoegang', life: 4000 })
        } finally {
          isSaving.value = false
        }
      }, 2000)
    },
    { deep: true }
  )

  const lastSavedLabel = () =>
    lastSaved.value ? `Opgeslagen om ${format(lastSaved.value, 'HH:mm')}` : null

  return { isSaving, lastSaved, lastSavedLabel }
}
